/* =============================================================================
   configurateur-galerie.js — Pont image pour Globo Product Options
   - auto-détection du sélecteur de coloris (indépendant du nom de l'option)
   - rendu des vignettes ROBUSTE (styles inline, immunisés contre le CSS du thème)
   - neutralise le sticky natif du thème sur ce produit (corrige le bug de scroll)
   ============================================================================= */
(() => {
  const root = document.querySelector('[data-cfg]');
  if (!root) return;

  const data     = JSON.parse(root.querySelector('[data-cfg-data]').textContent);
  const elMain   = root.querySelector('[data-cfg-main]');
  const elThumbs = root.querySelector('[data-cfg-thumbs]');

  const norm = s => (s || '').trim().toLowerCase();
  const byKey = {};
  data.colors.forEach(c => { byKey[norm(c.key)] = c; });
  const knownKeys = new Set(Object.keys(byKey));

  let current = null, shot = 0;

  /* --- STICKY PROPRE ---------------------------------------------------------
     Le thème utilise un sticky "directionnel" piloté en JS (colle en descendant,
     saute au scroll up) — bugué sur tous les produits. On le coupe sur ce produit
     et on le remplace par un position:sticky CSS classique, fluide dans les deux
     sens. On l'applique au conteneur média, dont le parent (.product__media-wrapper)
     est assez haut pour laisser défiler. --------------------------------------- */
  const mediaContainer = root.closest('.product__media-container');
  if (mediaContainer) {
    mediaContainer.classList.remove('sticky-element'); // neutralise le sticky JS du thème
    mediaContainer.style.position = 'sticky';
    mediaContainer.style.top = '24px';
    mediaContainer.style.alignSelf = 'flex-start';
  }

  /* --- lecture du coloris coché, quel que soit le nom du champ Globo --- */
  const readColor = () => {
    for (const el of document.querySelectorAll('input:checked')) {
      if (el.value && knownKeys.has(norm(el.value))) return el.value;
    }
    for (const el of document.querySelectorAll('select')) {
      if (el.value && knownKeys.has(norm(el.value))) return el.value;
    }
    return null;
  };

  /* --- rendu de la galerie --- */
  function renderGallery(c) {
    if (!c || !c.images.length) return;
    const active = c.images[shot] || c.images[0];
    elMain.src = active.src;
    elMain.alt = active.alt;

    // grille : autant de colonnes que de photos, sur toute la largeur.
    // Tout est posé en inline pour que le thème ne puisse rien casser.
    elThumbs.innerHTML = '';
    elThumbs.style.display = 'grid';
    elThumbs.style.gap = '12px';
    elThumbs.style.width = '100%';
    elThumbs.style.gridTemplateColumns = `repeat(${c.images.length}, 1fr)`;

    c.images.forEach((img, i) => {
      const t = document.createElement('button');
      t.type = 'button';
      t.className = 'cfg__thumb';
      t.setAttribute('aria-current', i === shot);
      // min-width:0 = correctif clé qui empêche les images de faire déborder la grille
      t.style.cssText = 'min-width:0;width:100%;margin:0;padding:0;aspect-ratio:1;overflow:hidden;cursor:pointer;';
      t.innerHTML = `<img src="${img.src}" alt="" loading="lazy" style="width:100%;height:100%;object-fit:cover;display:block;">`;
      t.addEventListener('click', () => { shot = i; renderGallery(c); });
      elThumbs.appendChild(t);
    });
  }

  function update() {
    const val = readColor();
    if (val == null) return;
    const c = byKey[norm(val)];
    if (!c) { console.warn('[cfg] coloris non mappé au metaobject :', val); return; }
    if (c === current) return;
    current = c; shot = 0;
    renderGallery(c);
  }

  document.addEventListener('change', update);

  let tries = 0;
  const timer = setInterval(() => {
    if (readColor() != null) { clearInterval(timer); update(); }
    else if (++tries > 60)   { clearInterval(timer); }
  }, 250);
})();